/** Shared card chrome and field pieces for the auth screens. */
export function AuthCard(props: {
  eyebrow: string;
  title: string;
  intro: string;
  context?: "register" | undefined;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <main className="fr-auth-page" data-context={props.context}>
      <div className="fr-auth-brand">
        <img className="fr-auth-logo" src="/img/logo-header.png" alt="" />
        <span>Fairway Rivalry</span>
      </div>
      <section className="fr-auth-card" aria-labelledby="auth-title">
        <div className="fr-auth-eyebrow">{props.eyebrow}</div>
        <h1 className="fr-auth-h2" id="auth-title">
          {props.title}
        </h1>
        <p className="fr-auth-sub">{props.intro}</p>
        {props.children}
      </section>
    </main>
  );
}

export function AuthField(props: {
  label: string;
  hint?: string;
  icon: React.ReactNode;
  trailing?: React.ReactNode;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <label className="fr-auth-field">
      <span>
        {props.label} {props.hint ? <small>{props.hint}</small> : null}
      </span>
      <div className="fr-auth-inwrap">
        {props.icon}
        {props.children}
        {props.trailing}
      </div>
    </label>
  );
}

export function EyeToggle(props: {
  shown: boolean;
  onToggle(): void;
}): React.JSX.Element {
  return (
    <button
      type="button"
      className="fr-auth-eye"
      aria-label={props.shown ? "Hide password" : "Show password"}
      onClick={props.onToggle}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6z" />
        <circle cx="12" cy="12" r="2.8" />
        {props.shown ? <path d="M4 4l16 16" /> : null}
      </svg>
    </button>
  );
}

const iconProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

export function MailIcon(): React.JSX.Element {
  return (
    <svg {...iconProps}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </svg>
  );
}

export function LockIcon(): React.JSX.Element {
  return (
    <svg {...iconProps}>
      <rect x="5" y="10" width="14" height="10" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </svg>
  );
}

export function PersonIcon(): React.JSX.Element {
  return (
    <svg {...iconProps}>
      <circle cx="12" cy="8" r="3.4" />
      <path d="M5.5 19.5c.9-3.6 3.3-5.4 6.5-5.4s5.6 1.8 6.5 5.4" />
    </svg>
  );
}
